import type { ChatResponse, CreateChangeRequest, PersonalViewResponse, PublicJobInfo, RegisterRequest, RegisterResponse } from '@crew/shared';
import { demoStore } from '@/demo/demoStore';
import { IS_DEMO } from '@/demo/demoMode';
import { apiRequest } from './api';

/** נקודות הקצה הציבוריות — לקבלנים ולעובדים, בלי התחברות. */
const enc = encodeURIComponent;

export const publicApi = {
  enter(slug: string, code: string): Promise<PublicJobInfo> {
    if (IS_DEMO) return demoStore.enter(slug, code);
    return apiRequest(`/api/public/jobs/${enc(slug)}/enter`, { method: 'POST', body: { code } });
  },
  register(slug: string, body: RegisterRequest): Promise<RegisterResponse> {
    if (IS_DEMO) return demoStore.register(slug, body);
    return apiRequest(`/api/public/jobs/${enc(slug)}/register`, { method: 'POST', body });
  },
  personal(token: string): Promise<PersonalViewResponse> {
    if (IS_DEMO) return demoStore.personal(token);
    return apiRequest(`/api/public/me/${enc(token)}`);
  },
  createRequest(token: string, body: CreateChangeRequest): Promise<{ requestId: string }> {
    if (IS_DEMO) return demoStore.createRequest(token, body.requestedCount, body.note ?? '');
    return apiRequest(`/api/public/me/${enc(token)}/requests`, { method: 'POST', body });
  },
  cancelRequest(token: string): Promise<{ ok: true }> {
    if (IS_DEMO) return demoStore.cancelRequest(token);
    return apiRequest(`/api/public/me/${enc(token)}/requests/cancel`, { method: 'POST', body: {} });
  },
  markSeen(token: string): Promise<unknown> {
    if (IS_DEMO) return demoStore.markSeen(token);
    return apiRequest(`/api/public/me/${enc(token)}/announcements/seen`, { method: 'POST', body: {} });
  },
  chat(token: string): Promise<ChatResponse> {
    if (IS_DEMO) return demoStore.contractorChat(token);
    return apiRequest(`/api/public/me/${enc(token)}/messages`);
  },
  sendMessage(token: string, text: string): Promise<unknown> {
    if (IS_DEMO) return demoStore.contractorSend(token, text);
    return apiRequest(`/api/public/me/${enc(token)}/messages`, { method: 'POST', body: { text } });
  },
  markChatRead(token: string): Promise<unknown> {
    if (IS_DEMO) return demoStore.contractorRead(token);
    return apiRequest(`/api/public/me/${enc(token)}/messages/read`, { method: 'POST', body: {} });
  },
};

/** הקישור האישי המלא לשליחה. */
export function personalUrl(token: string): string {
  return `${window.location.origin}/c/${token}`;
}
